import styled from '@emotion/styled';

export const Button = styled.button`
  background: none;
  border: none;
  display: flex;
  cursor: pointer;
  padding: var(--spacing-4);
  color: var(--color-black);
  border-radius: var(--border-radius-s);
  transition: all 0.3s;

  &:hover {
    background-color: var(--color-neutral-20);
  }
`;
